import {vnTemplate} from "../../../../valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSimple_template} from "../../../../valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {imagePickerEdit_template} from "./imagePickerEdit_template";

declare var ko: any;

export class imagePicker_template_mockup extends vnTemplate {

    protected filterSimple: filterSimple_template;
    protected imageEdit: imagePickerEdit_template;

    protected getTemplateHtml(): string {

        return `
            <div class="w-lightbox w-img-picker" data-bind="css: { 'is-visible': isPickerShown }, template: { afterRender: onLoadTemplate }">
            
                <div class="lightbox-content img-picker" id="drop-area">
                
                    <div class="img-picker-header w-justify">
                        <div class="w-left">
                            <button class="btn secondary icon i-image" type="button">Add Image</button>
                            <button class="btn secondary icon i-gallery" type="button">Create Gallery</button>
                        </div>
                       <div class="w-right">
                            <button type="button" class="close-btn icon i-close"></button>
                        </div>
                    </div>
                    
                    <!--  LAST ADDED -->
                    <div class="img-picker-header thin">
                        <div class="w-justify">
                            <div class="w-left">
                                <h3 class="section-title secondary">Last Added</h3>
                            </div>
                        </div>                       
                        <div>
                            <div class="w-left">
                                <ul class="img-picker-list last-added">
                                    <li class="img-picker-item">
                                        <div class="dropdown">
                                            <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                            <div class="dropdown-list">
                                                 <button class="btn-icon icon i-view" title="View" type="button"><span>View</span></button>
                                                 <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                                 <button class="btn-icon icon i-insert-grid" title="Insert" type="button"><span>Insert</span></button>
                                                 <button class="btn-icon icon i-download" title="Download" type="button"><span>Download</span></button>
                                                 <button class="btn-icon icon i-add-to-gallery" title="Add to Gallery" type="button"><span>Add to Gallery</span></button>
                                                 <button class="btn-icon accent icon i-delete" title="Delete" type="button"><span>Delete</span></button>
                                            </div>                                   
                                            
                                        </div>
                                        <div class="ratio-content">
                                            <img src="https://cdn.britannica.com/38/188638-050-08A5704E/Tom-Hardy-British-2014.jpg" alt="">  
                                        </div> 
                                        
                                    </li>
                                    <li class="img-picker-item">
                                        <div class="dropdown">
                                            <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                            <div class="dropdown-list">
                                                 <button class="btn-icon icon i-view" title="View" type="button"><span>View</span></button>
                                                 <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                                 <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                                 <button class="btn-icon icon i-download" title="Download" type="button"><span>Download</span></button>
                                                 <button class="btn-icon icon i-add-to-gallery" title="Add to Gallery" type="button"><span>Add to Gallery</span></button>
                                                 <button class="btn-icon accent icon i-delete" title="Delete" type="button"><span>Delete</span></button>
                                            </div>                                   
  
                                        </div>                   
                                        <div class="ratio-content">
                                            <img src="https://cdn.britannica.com/38/188638-050-08A5704E/Tom-Hardy-British-2014.jpg" alt="">  
                                        </div> 
                                    </li>
                                    <li class="img-picker-item">
                                        <div class="dropdown">
                                            <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                            <div class="dropdown-list">
                                                 <button class="btn-icon icon i-view" title="View" type="button"><span>View</span></button>
                                                 <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                                 <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                                 <button class="btn-icon icon i-download" title="Download" type="button"><span>Download</span></button>
                                                 <button class="btn-icon icon i-add-to-gallery" title="Add to Gallery" type="button"><span>Add to Gallery</span></button>
                                                 <button class="btn-icon accent icon i-delete" title="Delete" type="button"><span>Delete</span></button>
                                            </div>                                   
                                        </div>                                     
                                        <div class="ratio-content">
                                            <img src="https://cdn.britannica.com/38/188638-050-08A5704E/Tom-Hardy-British-2014.jpg" alt="">  
                                        </div> 
                                    </li>                                   
                                </ul>
                            </div>
                        </div>                      
                    </div>
                   
                    <div class="img-picker-body">   
                        <div class="list-header w-justify">
                            <div class="w-left">
                                <div class="w-btn-tab">
                                    <button class="btn icon i-image" type="button">Images</button>
                                    <button class="btn icon i-gallery is-selected" type="button">Galleries</button>
                                </div>                               
                            </div>
                            <div class="w-center">
                                <div class="w-filter-keyword">
                                    <div class="w-search-feild icon i-search2">
                                        <input type="input" class="search-feild">
                                        <input type="hidden">
                                        <input type="hidden">
                                        <button class="close-btn icon i-x-after is-showing" id="close-btn" type="button"></button>
                                    </div>
                                </div>
                            </div>
                            <div class="w-right">
                                
                                <div>
                                    <label class="form-label form-label-box">Ratio</label>
                                    <div>
                                        <select>
                                            <option value="0">All</option>
                                            <option value="1">administrator</option>
                                            <option value="2">Website Manager</option>
                                            <option value="4">Editor</option>
                                            <option value="6">Writer</option>
                                            <option value="7">Accountant</option>
                                            <option value="8">Ad Manager</option>
                                            <option value="9">Outreach Specialist</option>
                                            <option value="10">Backlink Partner</option>
                                            <option value="11">Community Manager</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!--  IMG SORTING -->
                        <div class="list-header w-justify w-sorting">
                        
                            <div class="w-right">
                                <div class="form-group row">
                                    <select class="small" name="" id="">
                                        <option value="">most recent</option>
                                        <option value="">last recent</option>
                                        <option value="">alphabetical asc</option>
                                        <option value="">alphabetical des</option>
                                    </select>
                                </div>
                            </div>
                           
                        </div>
                        
                        <!--  IMG LIST-->
                        <div class="w-img-picker-list"> 
                            <ul class="img-picker-list search image">
                                       
                                <li class="img-picker-item icon is-selected">
                                    <div class="dropdown">
                                        <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                        <div class="dropdown-list">
                                             <button class="btn-icon icon i-view" title="View" type="button"><span>View</span></button>
                                             <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                             <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                             <button class="btn-icon icon i-download" title="Download" type="button"><span>Download</span></button>
                                             <button class="btn-icon icon i-add-to-gallery" title="Add to Gallery" type="button"><span>Add to Gallery</span></button>
                                             <button class="btn-icon accent icon i-delete" title="Delete" type="button"><span>Delete</span></button>
                                        </div>
                                    </div>
                                    <div class="ratio-content">
                                        <img src="https://cdn.britannica.com/38/188638-050-08A5704E/Tom-Hardy-British-2014.jpg" alt="">  
                                    </div> 
                                </li>
                                <li class="img-picker-item icon">
                                    <div class="dropdown">
                                        <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                        <div class="dropdown-list">
                                             <button class="btn-icon icon i-view" title="View" type="button"><span>View</span></button>
                                             <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                             <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                             <button class="btn-icon icon i-download" title="Download" type="button"><span>Download</span></button>
                                             <button class="btn-icon icon i-add-to-gallery" title="Add to Gallery" type="button"><span>Add to Gallery</span></button>
                                             <button class="btn-icon accent icon i-delete" title="Delete" type="button"><span>Delete</span></button>
                                        </div>
                                    </div>
                                    <div class="ratio-content">  
                                        <img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt="">
                                    </div> 
                                </li>
                                <li class="img-picker-item icon">
                                    <div class="dropdown">
                                        <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                        <div class="dropdown-list">
                                             <button class="btn-icon icon i-view" title="View" type="button"><span>View</span></button>
                                             <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                             <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                             <button class="btn-icon icon i-download" title="Download" type="button"><span>Download</span></button>
                                             <button class="btn-icon icon i-add-to-gallery" title="Add to Gallery" type="button"><span>Add to Gallery</span></button>
                                             <button class="btn-icon accent icon i-delete" title="Delete" type="button"><span>Delete</span></button>
                                        </div>
                                    </div>
                                    <div class="ratio-content">  
                                        <img src="https://i.pinimg.com/originals/19/c0/df/19c0df226ca83938c5e13a6393179018.jpg" alt="">
                                    </div> 
                                </li>
                                <li class="img-picker-item icon">
                                    <div class="dropdown">
                                        <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                        <div class="dropdown-list">
                                             <button class="btn-icon icon i-view" title="View" type="button"><span>View</span></button>
                                             <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                             <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                             <button class="btn-icon icon i-download" title="Download" type="button"><span>Download</span></button>
                                             <button class="btn-icon icon i-add-to-gallery" title="Add to Gallery" type="button"><span>Add to Gallery</span></button>
                                             <button class="btn-icon accent icon i-delete" title="Delete" type="button"><span>Delete</span></button>
                                        </div>
                                    </div>
                                    <div class="ratio-content">  
                                        <img src="https://i.pinimg.com/originals/19/c0/df/19c0df226ca83938c5e13a6393179018.jpg" alt="">
                                    </div> 
                                </li>
                                <li class="img-picker-item icon">
                                    <div class="dropdown">
                                        <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                        <div class="dropdown-list">
                                             <button class="btn-icon icon i-view" title="View" type="button"><span>View</span></button>
                                             <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                             <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                             <button class="btn-icon icon i-download" title="Download" type="button"><span>Download</span></button>
                                             <button class="btn-icon icon i-add-to-gallery" title="Add to Gallery" type="button"><span>Add to Gallery</span></button>
                                             <button class="btn-icon accent icon i-delete" title="Delete" type="button"><span>Delete</span></button>
                                        </div>
                                    </div>
                                    <div class="ratio-content">  
                                        <img src="https://i.pinimg.com/originals/19/c0/df/19c0df226ca83938c5e13a6393179018.jpg" alt="">
                                    </div> 
                                </li>
                                <li class="img-picker-item icon">
                                    <div class="dropdown">
                                        <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                        <div class="dropdown-list">
                                             <button class="btn-icon icon i-view" title="View" type="button"><span>View</span></button>
                                             <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                             <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                             <button class="btn-icon icon i-download" title="Download" type="button"><span>Download</span></button>
                                             <button class="btn-icon icon i-add-to-gallery" title="Add to Gallery" type="button"><span>Add to Gallery</span></button>
                                             <button class="btn-icon accent icon i-delete" title="Delete" type="button"><span>Delete</span></button>
                                        </div>
                                    </div>
                                    <div class="ratio-content">  
                                        <img src="https://i.pinimg.com/originals/19/c0/df/19c0df226ca83938c5e13a6393179018.jpg" alt="">
                                    </div> 
                                </li>
                                <li class="img-picker-item icon">
                                    <div class="dropdown">
                                        <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                        <div class="dropdown-list">
                                             <button class="btn-icon icon i-view" title="View" type="button"><span>View</span></button>
                                             <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                             <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                             <button class="btn-icon icon i-download" title="Download" type="button"><span>Download</span></button>
                                             <button class="btn-icon icon i-add-to-gallery" title="Add to Gallery" type="button"><span>Add to Gallery</span></button>
                                             <button class="btn-icon accent icon i-delete" title="Delete" type="button"><span>Delete</span></button>
                                        </div>
                                    </div>
                                    <div class="ratio-content">  
                                        <img src="https://i.pinimg.com/originals/19/c0/df/19c0df226ca83938c5e13a6393179018.jpg" alt="">
                                    </div> 
                                </li>
                                <li class="img-picker-item icon">
                                    <div class="dropdown">
                                        <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                        <div class="dropdown-list">
                                             <button class="btn-icon icon i-view" title="View" type="button"><span>View</span></button>
                                             <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                             <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                             <button class="btn-icon icon i-download" title="Download" type="button"><span>Download</span></button>
                                             <button class="btn-icon icon i-add-to-gallery" title="Add to Gallery" type="button"><span>Add to Gallery</span></button>
                                             <button class="btn-icon accent icon i-delete" title="Delete" type="button"><span>Delete</span></button>
                                        </div>
                                    </div>
                                    <div class="ratio-content">  
                                        <img src="https://i.pinimg.com/originals/19/c0/df/19c0df226ca83938c5e13a6393179018.jpg" alt="">
                                    </div> 
                                </li>
                                <li class="img-picker-item icon">
                                    <div class="dropdown">
                                        <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                        <div class="dropdown-list">
                                             <button class="btn-icon icon i-view" title="View" type="button"><span>View</span></button>
                                             <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                             <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                             <button class="btn-icon icon i-download" title="Download" type="button"><span>Download</span></button>
                                             <button class="btn-icon icon i-add-to-gallery" title="Add to Gallery" type="button"><span>Add to Gallery</span></button>
                                             <button class="btn-icon accent icon i-delete" title="Delete" type="button"><span>Delete</span></button>
                                        </div>
                                    </div>
                                    <div class="ratio-content">  
                                        <img src="https://i.pinimg.com/originals/19/c0/df/19c0df226ca83938c5e13a6393179018.jpg" alt="">
                                    </div> 
                                </li>
                                <li class="img-picker-item icon">
                                    <div class="dropdown">
                                        <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                        <div class="dropdown-list">
                                             <button class="btn-icon icon i-view" title="View" type="button"><span>View</span></button>
                                             <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                             <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                             <button class="btn-icon icon i-download" title="Download" type="button"><span>Download</span></button>
                                             <button class="btn-icon icon i-add-to-gallery" title="Add to Gallery" type="button"><span>Add to Gallery</span></button>
                                             <button class="btn-icon accent icon i-delete" title="Delete" type="button"><span>Delete</span></button>
                                        </div>
                                    </div>
                                    <div class="ratio-content">  
                                        <img src="https://hips.hearstapps.com/digitalspyuk.cdnds.net/17/03/1484759485-12813703-low-res-taboo.jpg?crop=0.668xw:1.00xh;0.218xw,0&resize=480:*" alt="">
                                    </div> 
                                </li>
                                <li class="img-picker-item icon is-selected">
                                    <div class="dropdown">
                                        <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                        <div class="dropdown-list">
                                             <button class="btn-icon icon i-view" title="View" type="button"><span>View</span></button>
                                             <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                             <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                             <button class="btn-icon icon i-download" title="Download" type="button"><span>Download</span></button>
                                             <button class="btn-icon icon i-add-to-gallery" title="Add to Gallery" type="button"><span>Add to Gallery</span></button>
                                             <button class="btn-icon accent icon i-delete" title="Delete" type="button"><span>Delete</span></button>
                                        </div>
                                    </div>
                                    <div class="ratio-content">  
                                        <img src="https://hips.hearstapps.com/digitalspyuk.cdnds.net/17/03/1484759485-12813703-low-res-taboo.jpg?crop=0.668xw:1.00xh;0.218xw,0&resize=480:*" alt="">
                                    </div> 
                                </li>
                                 <li class="img-picker-item icon">
                                    <div class="dropdown">
                                        <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                        <div class="dropdown-list">
                                             <button class="btn-icon icon i-view" title="View" type="button"><span>View</span></button>
                                             <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                             <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                             <button class="btn-icon icon i-download" title="Download" type="button"><span>Download</span></button>
                                             <button class="btn-icon icon i-add-to-gallery" title="Add to Gallery" type="button"><span>Add to Gallery</span></button>
                                             <button class="btn-icon icon i-delete" title="Delete" type="button"><span>Delete</span></button>
                                        </div>
                                    </div>
                                    <div class="ratio-content">  
                                        <img src="https://hips.hearstapps.com/digitalspyuk.cdnds.net/17/03/1484759485-12813703-low-res-taboo.jpg?crop=0.668xw:1.00xh;0.218xw,0&resize=480:*" alt="">
                                    </div> 
                                </li>
                               
                           </ul>
                       </div>
                       
                       <!--  GALLERY LIST-->
                        <div style="display: none" class="w-img-picker-list">
                            <ul class="img-picker-list search gallery">
                                       
                                <li class="img-picker-item icon">
                                    <div class="dropdown">
                                        <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                        <div class="dropdown-list">
                                             <button class="btn-icon icon i-view" title="View" type="button"><span>View</span></button>
                                             <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                             <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                             <button class="btn-icon icon i-delete" title="Delete" type="button"><span>Delete</span></button>
                                        </div>                              
                                    </div>
                                    <div class="ratio-content gallery">    
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                    </div> 
                                </li>
                                <li class="img-picker-item icon">
                                    <div class="dropdown">
                                        <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                        <div class="dropdown-list">
                                             <button class="btn-icon icon i-view" title="View" type="button"><span>View</span></button>
                                             <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                             <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                             <button class="btn-icon icon i-delete" title="Delete" type="button"><span>Delete</span></button>
                                        </div>
                                    </div>
                                    <div class="ratio-content gallery">  
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                    </div> 
                                </li>
                                <li class="img-picker-item icon">
                                    <div class="dropdown">
                                        <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                        <div class="dropdown-list">
                                             <button class="btn-icon icon i-view" title="View" type="button"><span>View</span></button>
                                             <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                             <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                             <button class="btn-icon icon i-delete" title="Delete" type="button"><span>Delete</span></button>
                                        </div>
                                    </div>
                                    <div class="ratio-content gallery">    
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                        <div><img src="https://i.pinimg.com/originals/19/c0/df/19c0df226ca83938c5e13a6393179018.jpg" alt=""></div>                              
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                    </div> 
                                </li>
                                <li class="img-picker-item icon">
                                    <div class="dropdown">
                                        <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                        <div class="dropdown-list">
                                             <button class="btn-icon icon i-view" title="View" type="button"><span>View</span></button>
                                             <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                             <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                             <button class="btn-icon icon i-delete" title="Delete" type="button"><span>Delete</span></button>
                                        </div>
                                    </div>
                                    <div class="ratio-content gallery">    
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                        <div><img src="https://i.pinimg.com/originals/19/c0/df/19c0df226ca83938c5e13a6393179018.jpg" alt=""></div>                              
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                    </div>  
                                </li>
                                <li class="img-picker-item icon">
                                    <div class="dropdown">
                                        <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                        <div class="dropdown-list">
                                             <button class="btn-icon icon i-view" title="View" type="button"><span>View</span></button>
                                             <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                             <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                             <button class="btn-icon icon i-delete" title="Delete" type="button"><span>Delete</span></button>
                                        </div>
                                    </div>
                                    <div class="ratio-content gallery">    
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                        <div><img src="https://i.pinimg.com/originals/19/c0/df/19c0df226ca83938c5e13a6393179018.jpg" alt=""></div>                              
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                    </div>  
                                </li>
                                <li class="img-picker-item icon">
                                    <div class="dropdown">
                                        <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                        <div class="dropdown-list">
                                             <button class="btn-icon icon i-view" title="View" type="button"><span>View</span></button>
                                             <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                             <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                             <button class="btn-icon icon i-delete" title="Delete" type="button"><span>Delete</span></button>
                                        </div>
                                    </div>
                                    <div class="ratio-content gallery">    
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                        <div><img src="https://i.pinimg.com/originals/19/c0/df/19c0df226ca83938c5e13a6393179018.jpg" alt=""></div>                              
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                    </div> 
                                </li>
                                <li class="img-picker-item icon">
                                    <div class="dropdown">
                                        <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                        <div class="dropdown-list">
                                             <button class="btn-icon icon i-view" title="View" type="button"><span>View</span></button>
                                             <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                             <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                             <button class="btn-icon icon i-delete" title="Delete" type="button"><span>Delete</span></button>
                                        </div>
                                    </div>
                                    <div class="ratio-content gallery">    
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                        <div><img src="https://i.pinimg.com/originals/19/c0/df/19c0df226ca83938c5e13a6393179018.jpg" alt=""></div>                              
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                    </div> 
                                </li>
                                <li class="img-picker-item icon">
                                    <div class="dropdown">
                                        <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                        <div class="dropdown-list">
                                             <button class="btn-icon icon i-view" title="View" type="button"><span>View</span></button>
                                             <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                             <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                             <button class="btn-icon icon i-delete" title="Delete" type="button"><span>Delete</span></button>
                                        </div>
                                    </div>
                                    <div class="ratio-content gallery">    
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                        <div><img src="https://i.pinimg.com/originals/19/c0/df/19c0df226ca83938c5e13a6393179018.jpg" alt=""></div>                              
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                    </div> 
                                </li>
                                <li class="img-picker-item icon">
                                    <div class="dropdown">
                                        <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                        <div class="dropdown-list">
                                             <button class="btn-icon icon i-view" title="View" type="button"><span>View</span></button>
                                             <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                             <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                             <button class="btn-icon icon i-delete" title="Delete" type="button"><span>Delete</span></button>
                                        </div>
                                    </div>
                                    <div class="ratio-content gallery">    
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                        <div><img src="https://i.pinimg.com/originals/19/c0/df/19c0df226ca83938c5e13a6393179018.jpg" alt=""></div>                              
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                    </div>  
                                </li>
                                <li class="img-picker-item icon">
                                    <div class="dropdown">
                                        <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                        <div class="dropdown-list">
                                             <button class="btn-icon icon i-view" title="View" type="button"><span>View</span></button>
                                             <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                             <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                             <button class="btn-icon icon i-delete" title="Delete" type="button"><span>Delete</span></button>
                                        </div>
                                    </div>
                                    <div class="ratio-content gallery">    
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                        <div><img src="https://i.pinimg.com/originals/19/c0/df/19c0df226ca83938c5e13a6393179018.jpg" alt=""></div>                              
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                    </div>  
                                </li>
                                <li class="img-picker-item icon is-selected">
                                    <div class="dropdown">
                                        <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                        <div class="dropdown-list">
                                             <button class="btn-icon icon i-view" title="View" type="button"><span>View</span></button>
                                             <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                             <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                             <button class="btn-icon icon i-delete" title="Delete" type="button"><span>Delete</span></button>
                                        </div>
                                    </div>
                                    <div class="ratio-content gallery">    
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                        <div><img src="https://i.pinimg.com/originals/19/c0/df/19c0df226ca83938c5e13a6393179018.jpg" alt=""></div>                              
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                    </div> 
                                </li>
                                 <li class="img-picker-item icon">
                                    <div class="dropdown">
                                        <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                        <div class="dropdown-list">
                                             <button class="btn-icon icon i-view" title="View" type="button"><span>View</span></button>
                                             <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                             <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                             <button class="btn-icon icon i-delete" title="Delete" type="button"><span>Delete</span></button>
                                        </div>
                                    </div>
                                    <div class="ratio-content gallery">    
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                        <div><img src="https://i.pinimg.com/originals/19/c0/df/19c0df226ca83938c5e13a6393179018.jpg" alt=""></div>                              
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                        <div><img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt=""></div>                              
                                    </div> 
                                </li>
                               
                           </ul>
                       </div>
                    </div>      
                    
                    <!-- VIEW IMG -->
                    <div class="w-img-picker-view">
                    
                        <div class="img-picker-view ">
                            <div class="view-header">
                                <strong>Image title</strong>             
                                <button type="button" class="close-btn icon i-close"></button>
                            </div>
                            <div class="view-body center">
                            
                                <div class="view-img-container">
                                    <div class="w-img-optimization">
                                        
                                    </div>
                                    <img src="https://hips.hearstapps.com/esq.h-cdn.co/assets/15/20/4000x2000/landscape-1431901793-esq050114hardy009-tom-hardy.jpg?resize=980:*" alt="">
                                    <!-- <img src="https://static01.nyt.com/images/2017/01/08/arts/08HARDY1/08HARDY1-superJumbo.jpg" alt=""> -->
                                </div>
                                
                                <div class="w-view-info">
                                   
                                    <div class="view-info">
                                        <strong>Image title</strong>
                                        <p>Curabitur rutrum dui ut odio hendrerit malesuada. Mauris hendrerit nulla mattis massa congue, ut blandit mauris sagittis. Ut odio enim, ullamcorper vitae tincidunt in, porta sit amet ipsum.</p>                    
                                    </div>
                                    <dl class="view-info double-list">
                                        <dt><span>ratio</span></dt>
                                        <dd><span>mime</span></dd>
                                        <dt><span>ratio</span></dt>
                                        <dd><span>jpg</span></dd>
                                        <dt><span>dimension</span></dt>
                                        <dd><span>1200x600</span></dd>
                                        <dt><span>file size</span></dt>
                                        <dd><span>3MB</span></dd>
                                    </dl>
                                </div>
                            </div>
                            <div class="view-footer">
                                <button class="btn icon i-add-to-gallery" title="Add to Gallery" type="button">Add to Gallery</button>
                                <button class="btn icon i-edit" title="Edit" type="button">Edit</button>
                                <button class="btn icon i-select" title="Select" type="button">Select</button>
                                <button class="btn icon i-insert" title="Insert" type="button">Insert</button>
                                <button class="btn icon i-download" title="Donwload" type="button">Download</button>
                                <button class="btn icon i-full-size" title="View Original" type="button">View Original</button>
                                <button class="btn icon accent i-delete" title="Delete" type="button">Delete</button>
                            </div>
                        </div> 
                        
                    </div> 
                    
                    <!-- VIEW GALLERY -->
                    <div class="w-img-picker-view" >
                    
                        <div class="img-picker-view">
                            <div class="view-header">
                                <strong>Gallery Title(5)</strong>             
                                <button type="button" class="close-btn icon i-close"></button>
                            </div>
                            <div class="view-body">
                                <strong>Galery Name(3)</strong>
                                <div class="w-view-img-list">
                                    <ul class="view-img-list">
                                           
                                        <li class="view-img-item">
                                            <div class="dropdown">
                                                <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                                <div class="dropdown-list">
                                                     <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                                     <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                                     <button class="btn-icon icon i-download" title="Download" ype="button"><span>Download</span></button>
                                                     <button class="btn-icon icon i-remove-to-gallery" title="Remove from Group" type="button"><span>Remove from Group</span></button>
                                                     <button class="btn-icon icon i-full-size" title="View Real Size" type="button"><span>View Real size</span></button>
                                                </div>
                                            </div>
                                            <div class="view-img-container">
                                                <img src="https://c.files.bbci.co.uk/E823/production/_104372495_hardy1_pa.jpg" alt="">
                                            </div> 
                                        </li>
                                        <li class="view-img-item">
                                            <div class="dropdown">
                                                <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                                <div class="dropdown-list">
                                                     <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                                     <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                                     <button class="btn-icon icon i-download" title="Download" ype="button"><span>Download</span></button>
                                                     <button class="btn-icon icon i-remove-to-gallery" title="Remove from Gallery" type="button"><span>Remove from Gallery</span></button>
                                                     <button class="btn-icon icon i-full-size" title="View Real Size" type="button"><span>View Real size</span></button>
                                                </div>
                                            </div>
                                            <div class="view-img-container">
                                                <img src="https://c.files.bbci.co.uk/E823/production/_104372495_hardy1_pa.jpg" alt="">
                                            </div> 
                                        </li>
                                        <li class="view-img-item">
                                            <div class="dropdown">
                                                <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                                <div class="dropdown-list">
                                                     <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                                     <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                                     <button class="btn-icon icon i-download" title="Download" ype="button"><span>Download</span></button>
                                                     <button class="btn-icon icon i-remove-to-gallery" title="Remove from Gallery" type="button"><span>Remove from Gallery</span></button>
                                                     <button class="btn-icon icon i-full-size" title="View Real Size" type="button"><span>View Real size</span></button>
                                                </div>
                                            </div>
                                            <div class="view-img-container">
                                                <img src="https://i.pinimg.com/originals/19/c0/df/19c0df226ca83938c5e13a6393179018.jpg" alt="">
                                            </div> 
                                        </li>
                                        <li class="view-img-item">
                                            <div class="dropdown">
                                                <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                                <div class="dropdown-list">
                                                     <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                                     <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                                     <button class="btn-icon icon i-download" title="Download" ype="button"><span>Download</span></button>
                                                     <button class="btn-icon icon i-remove-to-gallery" title="Remove from Gallery" type="button"><span>Remove from Gallery</span></button>
                                                     <button class="btn-icon icon i-full-size" title="View Real Size" type="button"><span>View Real size</span></button>
                                                </div>
                                            </div>
                                            <div class="view-img-container">
                                                <img src="https://i.pinimg.com/originals/19/c0/df/19c0df226ca83938c5e13a6393179018.jpg" alt="">
                                            </div> 
                                        </li>
                                        <li class="view-img-item">
                                            <div class="dropdown">
                                                <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                                <div class="dropdown-list">
                                                     <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                                     <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                                     <button class="btn-icon icon i-download" title="Download" ype="button"><span>Download</span></button>
                                                     <button class="btn-icon icon i-remove-to-gallery" title="Remove from Gallery" type="button"><span>Remove from Gallery</span></button>
                                                     <button class="btn-icon icon i-full-size" title="View Real Size" type="button"><span>View Real size</span></button>
                                                </div>
                                            </div>
                                            <div class="view-img-container"> 
                                                <img src="https://i.pinimg.com/originals/19/c0/df/19c0df226ca83938c5e13a6393179018.jpg" alt="">
                                            </div> 
                                        </li>
                                        <li class="view-img-item">
                                            <div class="dropdown">
                                                <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                                <div class="dropdown-list">
                                                     <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                                     <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                                     <button class="btn-icon icon i-download" title="Download" ype="button"><span>Download</span></button>
                                                     <button class="btn-icon icon i-remove-to-gallery" title="Remove from Gallery" type="button"><span>Remove from Gallery</span></button>
                                                     <button class="btn-icon icon i-full-size" title="View Real Size" type="button"><span>View Real size</span></button>
                                                </div>
                                            </div>
                                            <div class="view-img-container">  
                                                <img src="https://i.pinimg.com/originals/19/c0/df/19c0df226ca83938c5e13a6393179018.jpg" alt="">
                                            </div> 
                                        </li>
                                        <li class="view-img-item">
                                            <div class="dropdown">
                                                <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                                <div class="dropdown-list">
                                                     <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>
                                                     <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                                     <button class="btn-icon icon i-download" title="Download" ype="button"><span>Download</span></button>
                                                     <button class="btn-icon icon i-remove-to-gallery" title="Remove from Gallery" type="button"><span>Remove from Gallery</span></button>
                                                     <button class="btn-icon icon i-full-size" title="View Real Size" type="button"><span>View Real size</span></button>
                                                </div>
                                            </div>
                                            <div class="view-img-container">
                                                <img src="https://i.pinimg.com/originals/19/c0/df/19c0df226ca83938c5e13a6393179018.jpg" alt="">
                                            </div> 
                                        </li>
                                       
                                    </ul>
                                </div>
                                
                                
                            </div>
                            <div class="view-footer">
                                <button class="btn icon i-insert" title="Insert" type="button">Insert</button>
                                <button class="btn accent icon i-delete" title="Delete" type="button">Delete</button>
                                <button class="btn icon i-edit" title="Edit" type="button">Edit</button>

                            </div>
                        </div> 
                        
                    </div> 
                    
                    <!-- ADD IMG-->
                    <div class="w-img-picker-form "><!-- is-visible -->
                   
                        <div class="img-picker-form">
                        
                            <div class="form-header">
                                <div class="w-section-title">
                                    <h3 class="section-title">Add a new image</h3>
                                </div>
                                <button type="button" class="close-btn icon i-close"></button>
                            </div>
                            
                            <div class="form-body vertical-center center-content">
                                <progress id="progress-bar" max=100 value=0></progress>
                            </div>
                            
                            <div class="form-body vertical-center center-content">
                                <div class="form-group">
                                    <div class="from-droparea">
                                    
                                    </div>
                                </div>
                                <div class="form-group">
                                    <span class="form-text"> or</span>
                                </div>                             
                                <div class="form-group">
                                    <button type="button" class="btn dark">Select Image</button>
                                </div>
                            </div>
                            
                            <div class="form-footer hide">
                                
                            </div>
                        </div>
                    </div>
                    
                    <!-- EDIT-NEW IMG -->
                    <div class="w-img-picker-form"><!-- is-visible -->
                   
                        <div class="img-picker-form">
                            <div class="form-header">
                                <div class="section-title">
                                    <h3 class="section-title">Edit image</h3>   
                                </div>                                        
                                <button type="button" class="close-btn icon i-close"></button>
                            </div>

                            <div class="form-body" >
                                
                                <div class="form-group">
                                    <div class="form-img-container">
                                        <img src="https://static01.nyt.com/images/2017/01/08/arts/08HARDY1/08HARDY1-superJumbo.jpg" alt="">
                                    </div>
                                </div>
                                <div class="form-group">
                                    <dl class="double-list">
                                        <dt><span>ratio</span></dt>
                                        <dd><span>mime</span></dd>
                                        <dt><span>ratio</span></dt>
                                        <dd><span>jpg</span></dd>
                                        <dt><span>dimension</span></dt>
                                        <dd><span>1200x600</span></dd>
                                        <dt><span>file size</span></dt>
                                        <dd><span>3MB</span></dd>
                                    </dl>
                                </div>
                                <div class="form-group">
                                    <label class="form-label" for="">title</label>
                                    <input class="input-text" type="text">
                                </div>
                                <div class="form-group">
                                    <label class="form-label" for="">Description</label>
                                    <textarea rows="4" name="" id=""></textarea>
                                </div>
                            </div>
                            
                             <div class="form-footer">
                                <button type="button" class="btn">Cancel</button>
                                <button type="button" class="btn highlight">Save</button>
                            </div>
                            
                        </div>
                    </div>
                    
                     <!-- EDIT-NEW GALLRY -->
                    <div class="w-img-picker-form "><!-- is-visible -->
                   
                        <div class="img-picker-form">
                            <div class="form-header">
                                <div class="w-section-title">
                                    <h3 class="section-title">Edit Gallery</h3>
                                    
                                    <div class="dropdown">
                                        <button type="button" class="btn only-icon icon i-option"></button>
                                        <div class="dropdown-list">
                                             <button class="btn-icon icon i-view" title="View" type="button"><span>view</span></button>
                                             <button class="btn-icon icon i-upload" title="Upload Image" type="button"><span>upload image</span></button>
                                        </div>
                                    </div>
                                </div>
                                <button type="button" class="close-btn icon i-close"></button>
                            </div>

                            <div class="form-body" >
                            
                                <div class="form-group">
                                    <label class="form-label" for="">title</label>
                                    <input class="input-text" type="text">
                                </div>
                                <div class="form-group">
                                    <label class="form-label" for="">Description</label>
                                    <textarea rows="4" name="" id=""></textarea>
                                </div>
       
                                <div class="form-group">
                                
                                   <ul class="img-picker-list">
                                   
                                        <li class="img-picker-item ">
                                            <button class="btn-icon icon i-drag"><span>drag</span></button>
                                            <div class="dropdown">
                                                <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                                <div class="dropdown-list">
                                                     <button class="btn-icon icon i-view" title="view" type="button"><span>view</span></button>
                                                     <button class="btn-icon icon i-remove-to-gallery" title="Remove from Gallery" type="button"><span>Remove from Gallery</span></button>
                                                </div>
                                            </div>
                                            <div class="ratio-content">
                                                <img src="https://i.pinimg.com/originals/19/c0/df/19c0df226ca83938c5e13a6393179018.jpg" alt="">  
                                            </div> 
                                        </li>
                                        <li class="img-picker-item">
                                            <button class="btn-icon icon i-drag"><span>drag</span></button>
                                            <div class="dropdown">
                                                <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                                <div class="dropdown-list">
                                                     <button class="btn-icon icon i-view" title="view" type="button"><span>view</span></button>
                                                     <button class="btn-icon icon i-remove-to-gallery" title="Remove from Gallery" type="button"><span>Remove from Gallery</span></button>
                                                </div>
                                            </div>
                                            <div class="ratio-content">  
                                                <img src="https://pyxis.nymag.com/v1/imgs/0aa/7b3/3aeacbfc1ed3b4a357be73ec7102f21b08-06-tom-hardy-lede.rsocial.w1200.jpg" alt="">
                                            </div> 
                                        </li>
                                        <li class="img-picker-item">
                                            <button class="btn-icon icon i-drag"><span>drag</span></button>
                                            <div class="dropdown">
                                                <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                                <div class="dropdown-list">
                                                     <button class="btn-icon icon i-view" title="view" type="button"><span>view</span></button>
                                                     <button class="btn-icon icon i-remove-to-gallery" title="Remove from Gallery" type="button"><span>Remove from Gallery</span></button>
                                                </div>
                                            </div>
                                            <div class="ratio-content">  
                                                <img src="https://i.pinimg.com/originals/19/c0/df/19c0df226ca83938c5e13a6393179018.jpg" alt="">
                                            </div> 
                                        </li>
                                        <li class="img-picker-item">
                                            <button class="btn-icon icon i-drag"><span>drag</span></button>
                                            <div class="dropdown">
                                                <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                                <div class="dropdown-list">
                                                     <button class="btn-icon icon i-view" title="view" type="button"><span>view</span></button>
                                                     <button class="btn-icon icon i-remove-to-gallery" title="Remove from Gallery" type="button"><span>Remove from Gallery</span></button>
                                                </div>
                                            </div>
                                            <div class="ratio-content">  
                                                <img src="https://hips.hearstapps.com/digitalspyuk.cdnds.net/17/03/1484759485-12813703-low-res-taboo.jpg?crop=0.668xw:1.00xh;0.218xw,0&resize=480:*" alt="">
                                            </div> 
                                        </li>
                                        <li class="img-picker-item">
                                            <button class="btn-icon icon i-drag"><span>drag</span></button>
                                            <div class="dropdown">
                                                <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                                <div class="dropdown-list">
                                                     <button class="btn-icon icon i-view" title="view" type="button"><span>view</span></button>
                                                     <button class="btn-icon icon i-remove-to-gallery" title="Remove from Gallery" type="button"><span>Remove from Gallery</span></button>
                                                </div>
                                            </div>
                                            <div class="ratio-content">  
                                                <img src="https://hips.hearstapps.com/digitalspyuk.cdnds.net/17/03/1484759485-12813703-low-res-taboo.jpg?crop=0.668xw:1.00xh;0.218xw,0&resize=480:*" alt="">
                                            </div> 
                                        </li>
                                       
                                   </ul>
                                   
                                </div>
                                
                            </div>
                            
                             <div class="form-footer">
                                <button type="button" class="btn">Cancel</button>
                                <button type="button" class="btn highlight">Save</button>
                            </div>
                            
                        </div>
                    </div>
                    
                   <!-- SELECTED SECTION-->
                   <div class="w-selection-panel"><!-- is-visible -->
                        <div class="selection-panel img">
                            <div class="selection-panel-header">
                                <strong class="icon i-image">Selected images (4)</strong>
                                <div class="dropdown">
                                    <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                    <div class="dropdown-list">
                                         <button class="btn-icon icon i-close" title="Deselectad all" type="button"><span>Deselectad all</span></button>
                                         <button class="btn-icon icon i-insert" title="Insert" type="button"><span>Insert</span></button>
                                         <button class="btn-icon icon i-add-to-gallery" title="Add to Gallery" type="button"><span>Add to Gallery</span></button>
                                    </div>
                                     
                                </div>
                            </div>
                            <div class="selection-panel-body">
                                <button class="btn-selected btn-preview" type="button"><span class="hide">preview</span></button>
                                <ul class="img-picker-list selected">
                                    <li class="img-picker-item">
                                        <button class="btn icon i-close" type="button"></button>                            
                                        <div class="ratio-content">
                                            <img src="https://cdn.britannica.com/38/188638-050-08A5704E/Tom-Hardy-British-2014.jpg" alt="">  
                                        </div> 
                                    </li>
                                    <li class="img-picker-item"> 
                                        <button class="btn icon i-close" type="button"></button>                                                                       
                                        <div class="ratio-content">
                                            <img src="https://cdn.britannica.com/38/188638-050-08A5704E/Tom-Hardy-British-2014.jpg" alt="">  
                                        </div> 
                                    </li>
                                    <li class="img-picker-item"> 
                                        <button class="btn icon i-close" type="button"></button>                                  
                                        <div class="ratio-content">
                                            <img src="https://cdn.britannica.com/38/188638-050-08A5704E/Tom-Hardy-British-2014.jpg" alt="">  
                                        </div> 
                                    </li> 
                                    <li class="img-picker-item">
                                        <button class="btn icon i-close" type="button"></button>                                   
                                        <div class="ratio-content">
                                            <img src="https://cdn.britannica.com/38/188638-050-08A5704E/Tom-Hardy-British-2014.jpg" alt="">  
                                        </div> 
                                    </li> 
                                    <li class="img-picker-item"> 
                                        <button class="btn icon i-close" type="button"></button>                                  
                                        <div class="ratio-content">
                                            <img src="https://cdn.britannica.com/38/188638-050-08A5704E/Tom-Hardy-British-2014.jpg" alt="">  
                                        </div> 
                                    </li> 
                                    <li class="img-picker-item">    
                                        <button class="btn icon i-close" type="button"></button>                               
                                        <div class="ratio-content">
                                            <img src="https://cdn.britannica.com/38/188638-050-08A5704E/Tom-Hardy-British-2014.jpg" alt="">  
                                        </div> 
                                    </li> 
                                    <li class="img-picker-item">
                                        <button class="btn icon i-close" type="button"></button>                                   
                                        <div class="ratio-content">
                                            <img src="https://cdn.britannica.com/38/188638-050-08A5704E/Tom-Hardy-British-2014.jpg" alt="">  
                                        </div> 
                                    </li> 
                                    <li class="img-picker-item">
                                        <button class="btn icon i-close" type="button"></button>                                   
                                        <div class="ratio-content">
                                            <img src="https://cdn.britannica.com/38/188638-050-08A5704E/Tom-Hardy-British-2014.jpg" alt="">  
                                        </div> 
                                    </li> 
                                    <li class="img-picker-item"> 
                                        <button class="btn icon i-close" type="button"></button>                                  
                                        <div class="ratio-content">
                                            <img src="https://cdn.britannica.com/38/188638-050-08A5704E/Tom-Hardy-British-2014.jpg" alt="">  
                                        </div> 
                                    </li>                                   
                                </ul>
                                <button class="btn-selected btn-next is-active" type="button"><span class="hide">Next</span></button>
                            </div>
                        </div>
                        <div class="selection-panel gallery">
                            <div class="selection-panel-header gallery">
                                <div><strong class="icon i-gallery">Selected Gallery | [GalleryName](4) </strong>
                                <span class="unsaved icon i-save">Unsaved changes</span></div>
                                <div class="dropdown">
                                    <button class="btn-icon icon i-option dropdown-toggle"><span>options</span></button>
                                    <div class="dropdown-list">
                                         <button class="btn-icon icon i-upload" title="Upload Img" type="button"><span>Upload Img</span></button>
                                         <button class="btn-icon icon i-view" title="View" type="button"><span>View</span></button>
                                         <button class="btn-icon icon i-edit" title="Edit" type="button"><span>Edit</span></button>                                     
                                         <button class="btn-icon icon i-close" title="Deselect" type="button"><span>Deselect</span></button>
                                         <button class="btn-icon icon i-save" title="Save" type="button"><span>Save</span></button>
                                         <button class="btn-icon icon i-cancel" title="Cancel" type="button"><span>Cancel</span></button>
                                    </div>
                                     
                                </div>
                            </div>
                             <div class="selection-panel-body">
                                <button class="btn-selected btn-preview " type="button"><span class="hide">preview</span></button>
                                <ul class="img-picker-list selected">
                                    <li class="img-picker-item">
                                        <button class="btn icon i-close" type="button"></button>                                               
                                        <div class="ratio-content">
                                            <img src="https://cdn.britannica.com/38/188638-050-08A5704E/Tom-Hardy-British-2014.jpg" alt="">  
                                        </div> 
                                    </li>
                                    <li class="img-picker-item icon i-save">
                                        <button class="btn icon i-close" type="button"></button>                                               
                                        <div class="ratio-content">
                                            <img src="https://cdn.britannica.com/38/188638-050-08A5704E/Tom-Hardy-British-2014.jpg" alt="">  
                                        </div> 
                                    </li>
                                    <li class="img-picker-item">
                                        <button class="btn icon i-close" type="button"></button>                                               
                                        <div class="ratio-content">
                                            <img src="https://cdn.britannica.com/38/188638-050-08A5704E/Tom-Hardy-British-2014.jpg" alt="">  
                                        </div> 
                                    </li>                                   
                                </ul>
                                <button class="btn-selected btn-next is-active" type="button"><span class="hide">preview</span></button>
                            </div>
                        </div
                   </div>
                  
                                                  
                </div>
                
            </div>
            `;
    }

    private onLoadTemplate () {
        let dropArea = document.getElementById("drop-area");

        // Prevent default drag behaviors
        ;['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
            dropArea.addEventListener(eventName, preventDefaults, false)
            document.body.addEventListener(eventName, preventDefaults, false)
        });

        ;['dragenter', 'dragover'].forEach(eventName => {
            dropArea.addEventListener(eventName, highlight, false)
        });

        ;['dragleave', 'drop'].forEach(eventName => {
            dropArea.addEventListener(eventName, unhighlight, false)
        });

        //dropArea.addEventListener('drop', this.handleDrop2, false);

        function highlight(e) {
            dropArea.classList.add('highlight');
        }

        function unhighlight(e) {
            dropArea.classList.remove('highlight');
        }

        function preventDefaults (e) {
            e.preventDefault();
            e.stopPropagation();
        }

    }

    public getViewModelForRequest(){

        return {
             filters      : {
                keywords: this.getTemplateViewModel().filterSimple.filterKeyword,
            },
        }
    }



    protected initPartial(): void {

        this.filterSimple = new filterSimple_template("filterSimple", this.getTemplateViewModel(), this.caller);

        this.imageEdit = new imagePickerEdit_template("imageEdit", this.getTemplateViewModel(), this.caller);
    }

    protected getTemplateName(): string {
        return "imagePicker-template2";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return [];
    }

    protected buildViewModel(): any {

        //create observable array refresh function
        ko.observableArray.fn.refresh = function (item, index) {
            if (index==null) index = this['indexOf'](item);
            if (index >= 0) {
                this.splice(index, 1, ko.utils.extend({}, item)) // create new item
            }
        }

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return {
            isPickerShown: ko.observable(true),
            selectedImage: ko.observable(null),
            selectedImages: ko.observableArray([]),
            name: ko.observable(null),
            idImage: ko.observable(null),
            caption: ko.observable(null),
            description: ko.observable(null),
            altText: ko.observable(null),
            imageResults: ko.observableArray([]),
            onClickCancel: function(data, event){ huit_neuf_this.onClickCancel();},
            onLoadTemplate: function(data, event){ huit_neuf_this.onLoadTemplate();},
            onClickInsert: function(data, event){ huit_neuf_this.onClickInsert();},
            onClickInsertGallery: function(data, event){ huit_neuf_this.onClickInsertGallery();},
            onDropFile: function(data, event){ huit_neuf_this.onDropFile(event);},
            onClickImage: function(data, event){ huit_neuf_this.onClickImage(data);},
            onClickEdit: function(data, event){ huit_neuf_this.onClickEdit(data);},
            onAddFiles: function(data, event, files){ huit_neuf_this.onAddFiles(event);}
        };
    }

    protected onClickCancel(){

        this.getTemplateViewModel().isPickerShown(false);
    }

    protected onClickInsert(){

        let viewModel = this.getTemplateViewModel();
        let selectedImage = viewModel.selectedImage();

        let image = { id: viewModel.idImage(), 
                      url: selectedImage.url , 
                      name: viewModel.name(), 
                      caption: viewModel.caption(), 
                      description: viewModel.description(),
                      altText: viewModel.altText(),
                      width: selectedImage.width, 
                      height: selectedImage.height, 
                      fileSize: selectedImage.fileSize,
                      mimeType: selectedImage.mimeType };

        this.caller.insertImage(image);
    }

    protected onClickInsertGallery(){

        let viewModel = this.getTemplateViewModel();
        let selectedImage = viewModel.selectedImage();

        let selectedImages = viewModel.selectedImages();

        let selectedImageIds = [];

        for(let image of selectedImages){
            selectedImageIds.push(image.id);
        }

        this.caller.insertGallery(selectedImageIds);
    }

    protected onClickEdit(data){

        //this.setSelectedImage(image);
        //this.imageEdit.setSelectedImage(data);
    }

    public setImageResults(imageResults){
        this.getTemplateViewModel().imageResults(imageResults);
    }

    public addImageToResults(image){
        let results = this.getTemplateViewModel().imageResults;
        results().unshift(image);
        results.refresh(image,0);
        this.setSelectedImage(image);
    }

    protected onClickImage(data){

        data.selected = !data.selected;
        let selectedImages = this.getTemplateViewModel().selectedImages;
        //this.setSelectedImage(data);
        if(data.selected){

            let image = selectedImages().find(i => i.id === data.id);
            if(!image){
                selectedImages().push(data);
            }

        }else{

            selectedImages.splice(selectedImages().findIndex(i => i.id === data.id),1);
            //this.setSelectedImage(null);
        }

        selectedImages.refresh(data);
        let imageResults = this.getTemplateViewModel().imageResults;
        imageResults.refresh(data);

        //this.getTemplateViewModel().imageResults([]);
        //this.getTemplateViewModel().imageResults(imageResults);
    }

    protected setSelectedImage(image){


        if(image){
            this.getTemplateViewModel().selectedImage(image);
            this.getTemplateViewModel().idImage(image.id);
            this.getTemplateViewModel().name(image.name);
            this.getTemplateViewModel().caption(image.caption);
            this.getTemplateViewModel().altText(image.altText);
        }else{
            this.getTemplateViewModel().selectedImage(null);
            this.getTemplateViewModel().idImage(null);
            this.getTemplateViewModel().name(null);
            this.getTemplateViewModel().caption(null);
            this.getTemplateViewModel().altText(null);
        }


    }

    protected onAddFiles(event){
        this.caller.handleFiles(event.target.files);
    }

    protected onDropFile(e){

        let dt = e.dataTransfer;
        let files = dt.files;
        this.caller.handleFiles(files);
        //this.getTemplateViewModel().isPickerShown(false);
    }

    public setIsPickerShown(isPickerShown){

        this.getTemplateViewModel().isPickerShown(isPickerShown);
    }


}



// WEBPACK FOOTER //
// ./vendor/valnet/valnet_imagePicker/js/components/templates/imagePicker_template_mockup.ts